import AppIcon from '@/components/content/app/AppIcon'

import { getBrandColors, cn } from '@/lib/utils'
import type { App } from '@/payload-types'

type BlogIconProps = React.HTMLAttributes<HTMLDivElement> & {
  apps: App[]
}

export default function BlogIcon({ apps }: BlogIconProps) {
  const SPEED = 25
  const APP_HEIGHT = 16
  const GAP = 6

  const totalSetSize = apps.length * APP_HEIGHT + (apps.length - 1) * GAP
  const duration = totalSetSize / SPEED

  return (
    <div
      aria-hidden="true"
      className="relative h-10 w-14 shrink-0 overflow-hidden rounded bg-gradient-to-b from-black/0 via-black/0 to-black/10 shadow-[inset_0px_0px_0px_1px_rgba(0,0,0,0.06)] outline outline-[3px] outline-offset-[-3px] outline-black/10"
    >
      <div className="relative top-[3px] h-[34px] overflow-hidden">
        <div
          className={cn(
            'relative left-2.5 flex flex-col gap-1.5',
            apps.length > 2
              ? 'pause group-hover:play animate-marquee-vertical transition-[animation-play-state] duration-300'
              : 'top-1.5',
          )}
          style={
            {
              '--duration': `${duration}s`,
              '--single-set-size': `${totalSetSize}px`,
              '--offset-start': `${GAP}px`,
              '--offset-end': `0px`,
            } as React.CSSProperties
          }
        >
          <>
            {apps.map((app, index) => {
              const { backgroundColor } = getBrandColors(app)
              return (
                <AppIcon
                  key={`original-${index}`}
                  icon={app.icon}
                  glyph={app.glyph}
                  background={backgroundColor}
                  size={16}
                />
              )
            })}
            {apps.length > 2 &&
              apps.map((app, index) => {
                const { backgroundColor } = getBrandColors(app)
                return (
                  <AppIcon
                    key={`duplicate-${index}`}
                    icon={app.icon}
                    glyph={app.glyph}
                    background={backgroundColor}
                    size={16}
                  />
                )
              })}
          </>
        </div>
      </div>

      <div className="absolute right-3 top-1/2 h-2.5 w-2.5 -translate-y-1/2">
        <div className="mt-px flex flex-col gap-0.5">
          <span className="h-[1.5px] w-full rounded-full bg-gray-500"></span>
          <span className="h-[1.5px] w-1/2 rounded-full bg-gray-800"></span>
          <span className="h-[1.5px] w-full rounded-full bg-gray-400"></span>
        </div>
      </div>
    </div>
  )
}
